var map = {
	"./TaskActionView": [
		57759,
		7759
	],
	"./TaskActionView.jsx": [
		57759,
		7759
	],
	"./TaskAugmentedRealityView": [
		94843,
		4843
	],
	"./TaskAugmentedRealityView.jsx": [
		94843,
		4843
	],
	"./TaskCheckInView": [
		6009,
		6009
	],
	"./TaskCheckInView.jsx": [
		6009,
		6009
	],
	"./TaskInformationView": [
		78700,
		8700
	],
	"./TaskInformationView.jsx": [
		78700,
		8700
	],
	"./TaskMultipleChoiceImageView": [
		22847,
		2847
	],
	"./TaskMultipleChoiceImageView.jsx": [
		22847,
		2847
	],
	"./TaskMultipleChoiceView": [
		81361,
		1361
	],
	"./TaskMultipleChoiceView.jsx": [
		81361,
		1361
	],
	"./TaskNumpadView": [
		73156,
		3156
	],
	"./TaskNumpadView.jsx": [
		73156,
		3156
	],
	"./TaskPhotoView": [
		31991,
		1991
	],
	"./TaskPhotoView.jsx": [
		31991,
		1991
	],
	"./TaskPollingView": [
		87337,
		7337
	],
	"./TaskPollingView.jsx": [
		87337,
		7337
	],
	"./TaskScanQRView": [
		23794,
		3794
	],
	"./TaskScanQRView.jsx": [
		23794,
		3794
	],
	"./TaskShortAnswerView": [
		68393,
		8393
	],
	"./TaskShortAnswerView.jsx": [
		68393,
		8393
	],
	"./TaskSpotTheDifferenceView": [
		41320,
		1320
	],
	"./TaskSpotTheDifferenceView.jsx": [
		41320,
		1320
	],
	"./TaskSymbolPadView": [
		52000,
		8151,
		2000
	],
	"./TaskSymbolPadView.jsx": [
		52000,
		8151,
		2000
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 85569;
module.exports = webpackAsyncContext;